<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <div
          class="container-fluid menu-margin-top"
          id="dealer"
          style="padding-left:0px;padding-right:0px"
        >
          <!-- Start the code for this screen here -->
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Search Dealer Account</b>
              </span>
            </nav>
            <!--  Search Section with various options-->
            <!--  Display Error message that one search param required-->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label for="dname" class="col-form-label col-form-label-sm">Dealer Name</label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center">
                <input
                  type="text"
                  id="dname"
                  name="Dealer Name"
                  v-model.trim="searchCriteria.dealername"
                  class="form-control input-sm"
                />
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label for="state" class="col-form-label col-form-label-sm">Dealer State</label>
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-end align-items-center">
                <select
                  id="state"
                  v-model.trim="searchCriteria.stateCode"
                  class="form-control input-sm"
                >
                  <option disabled value>Select a State</option>
                  <option
                    v-for="state in states"
                    v-bind:value="state.stateFipsC"
                    v-bind:key="state.stateFipsC"
                  >{{state.stateN}}</option>
                </select>
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label for="zip" class="col-form-label col-form-label-sm">Zip Code</label>
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-end align-items-center">
                <input
                  type="text"
                  id="zip"
                  v-model.trim="searchCriteria.zipCode"
                  class="form-control input-sm"
                />
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label for="status" class="col-form-label col-form-label-sm">Dealer Status</label>
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-end align-items-center">
                <select
                  id="status"
                  v-model.trim="searchCriteria.status"
                  class="form-control input-sm"
                >

                 <option
                    v-for="dstatus in dealerStatusOptions"
                    v-bind:value="dstatus.value"
                    v-bind:key="dstatus.value"
                  >{{dstatus.text}}</option>
                </select>
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label for="red Flag" class="col-form-label col-form-label-sm">Red Flag</label>
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-end align-items-center">
                <select
                  id="status"
                  v-model.trim="searchCriteria.redFlag"
                  class="form-control input-sm"
                >
                  <option disabled>Select Flag</option>
                  <option
                    v-for="(flag, index) in redFalgOptions"
                    v-bind:value="flag.value"
                    v-bind:key="index"
                  >{{ flag.value }}</option>
                </select>
              </div>
            </div>

            <div class="center mt-2 mb-3">
              <button type="submit" @click="searchDealers" class="btn btn-secondary">Search</button>&nbsp;&nbsp;&nbsp;
              <button
                type="submit"
                @click="resetsearch"
                class="btn btn-secondary"
              >Reset</button>
            </div>

            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Display Dealers</b>
              </span>
            </nav>
            <!-- Table Data start-->
            <div class="row mt-2 justify-content-center">
              <div class="col">
                <div class="table-responsive table-responsive-sm tbl-update-dealer">
                  <v-table
                    id="dealerListTable"
                    :data="dealerListForDisplay"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead class="table-month-header-blue wrap-text" slot="head">
                         <v-th sortKey="dealerId">View/Edit</v-th>
                        <v-th sortKey="dealerId">View Deals</v-th>
                      <v-th sortKey="dealerName">Name</v-th>
                      <v-th sortKey="street1">Address</v-th>
                      <v-th sortKey="stateName">State</v-th>
                      <v-th sortKey="zipCode">Zip Code</v-th>
                      <v-th sortKey="dealerFraudIndicator">RedFlag</v-th>
                      <v-th sortKey="dealerStatus">Status</v-th>
                       <v-th sortKey="email">Primary Email</v-th>
                        <v-th sortKey="contactTitle">Primary Conatact Title</v-th>
                         <v-th sortKey="mobileNumber">Primary Mobile#</v-th>

                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr v-for="(dealer,dindex) in displayData" :key="dindex">
                         <td>
                          <button
                            type="submit"
                            class="btn btn-secondary btn-edit"
                            :disabled="!checkAccess('updateDealer')"
                            :class="{'disabled':!checkAccess('updateDealer')}"
                            @click="viewDealerDetails(dealer.dealerId)"
                          >View/Edit</button>
                        </td>
                         <td>
                          <button
                            type="submit"
                            class="btn btn-secondary btn-edit"
                            @click="viewDeals(dealer.dealerId,dealer.dealerName)"
                          >ViewDeals</button>
                        </td>
                        <td class="table-month-td">{{dealer.dealerName}}</td>
                        <td class="table-month-td">{{dealer.street1}}</td>
                        <td class="table-month-td">{{dealer.stateName}}</td>
                        <td class="table-month-td">{{dealer.zipCode}}</td>
                        <td class="table-month-td">{{ dealer.dealerFraudIndicator }}</td>
                        <td
                          class="table-month-td"
                        >{{dealer.dealerStatus === 'A' ? 'Active' : 'Inactive'}}</td>
                        <td class="table-month-td">{{dealer.email}}</td>
                         <td class="table-month-td">{{dealer.contactTitle}}</td>
                         <td class="table-month-td">{{dealer.mobileNumber}}</td>

                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
            <viewupdatedealermodal v-if="updateDealerModal" :UpdateDealerObject="UpdateDealerObject" @closeUpdateDealerModal="closeUpdateDealerModal(1000)"></viewupdatedealermodal>
            <!-- <template v-if="norecordsfound">
               <p align ="center" class="alert-danger"> No Records found!!! Refine your search</p>
            </template>-->
          </div>
        </div>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import { store } from '../store.js'
import manageSourceSvc from '../js/http-managesource'
import commonSvc from '../js/http-common'
import { bus } from '../main'
import viewupdatedealermodal from '../views/UpdateDealer.vue'
import { hasAccess } from '../js - Local/permissions.js'

export default {
  components: { MainMenu, TopHeader, BottomFooter, viewupdatedealermodal },
  name: 'Viewdealers',
  data () {
    return {
      updateDealerModal: false,
      UpdateDealerObject: null,
      radioselected: '',
      norecordsfound: false,
      searchCriteria: {
        dealername: '',
        stateCode: '',
        status: 'A',
        zipCode: '',
        redFlag: 'All'
      },
      colheaders: [
        { header: 'Name' },
        { header: 'Address' },
        { header: 'State' },
        { header: 'ZipCode' },
        { header: 'RedFlag' },
        { header: 'Status' },
        { header: 'Edit' }
      ],
      loading: false,
      dealerListForDisplay: [],
      selectedDealerId: '',
      error: false,
      states: [], // gets data from service
      dealerStatusOptions: [],
      redFalgOptions: [
        { name: 'All', value: 'All' },
        { name: 'Y', value: 'Y' },
        { name: 'N', value: 'N' }
      ],
      dealer_fields_export: {
        'Dealer Name': 'dealerName',
        'Address Line1': 'street1',
        'Address Line2': 'street2',
        City: 'city',
        State: 'stateName',
        'Zip Code': 'zipCode',
        Country: 'country',
        Status: 'dealerStatus',
        // 'Status':'dealerStatus == A ? "Active" : "Inactive" '
        'Dealer Activity Level': 'dealerActivityLevel',
        'Quote Days Back': 'dealerDays',
        'Employee First Name': 'firstName',
        'Employee Last Name': 'lastName',
        'Work Number': 'workNumber',
        'Mobile Number': 'mobileNumber',
        'Fax Number': 'faxNumber',
        Email: 'email'
      }
    }
  },
  methods: {
    fetchDataOnpageLoad () {
      this.searchDealers(),
      // this.getDealers(),
      this.retrieveStateList(),
      this.retrieveStatus()
    },
    // Get Dealers for export
    async getDealersToExport () {
      const response = await manageSourceSvc.get('/dealerreport')
      return response.data
    },
    closeUpdateDealerModal (value) {
      	setTimeout(() => { this.closepopup() }, value)
    },

    closepopup () {
      this.updateDealerModal = false
    },

    // Get Dealers
    getDealers () {
      manageSourceSvc
        .get('/dealersearchdata')
        .then(Response => {
          this.dealerListForDisplay = Response.data
        })
        .catch(error => {
          console.log('Failed to load dealer on page load:' + error)
          this.error = true
        })
        .finally(() => (this.loading = false))
    },
    retrieveStateList () {
      commonSvc
        .get('/statefip/')
        .then(response => {
          this.states = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveStatus () {
      commonSvc
        .get('/staticdata/status/')
        .then(response => {
          this.dealerStatusOptions = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    // Search Dealers
    searchDealers: function () {
      if (this.$session.get('user_role') == 'SR') {
        manageSourceSvc
          .get('/dealersearch', {
            params: {
              dealerName: this.searchCriteria.dealername,
              stateCode: this.searchCriteria.stateCode,
              zipCode: this.searchCriteria.zipCode,
              statusCode: this.searchCriteria.status,
              salesempId: this.$session.get('employee_id'),
              redFlag: this.searchCriteria.redFlag
            }
          })
          .then(response => {
            // console.log("Search Response: "+ JSON.stringify(response.data))
            this.dealerListForDisplay = response.data
            console.log('sales rep')
            if (this.dealerListForDisplay.length != 0) {
              this.norecordsfound = false
            } else {
              this.norecordsfound = true
            }
          })
          .catch(e => {
            console.log('Error during search API call')
            this.norecordsfound = true
          })
      } else {
        manageSourceSvc
          .get('/dealersearchdata', {
            params: {
              dealerName: this.searchCriteria.dealername,
              stateCode: this.searchCriteria.stateCode,
              zipCode: this.searchCriteria.zipCode,
              statusCode: this.searchCriteria.status,
              redFlag: this.searchCriteria.redFlag
              // salesempId:this.$session.get("employee_id")
            }
          })
          .then(response => {
            // console.log("Search Response: "+ JSON.stringify(response.data))
            this.dealerListForDisplay = response.data
            if (this.dealerListForDisplay.length != 0) {
              this.norecordsfound = false
            } else {
              this.norecordsfound = true
            }
          })
          .catch(e => {
            console.log('Error during search API call')
            this.norecordsfound = true
          })
      }
    },
    createeEmptySearchObject () {
      return {
        dealername: '',
        stateCode: '',
        status: 'A',
        zipCode: '',
        redFlag: 'All'
      }
    },
    viewDealerDetails: function (value) {
      // debugger
      this.$store.state.dealerId = value
      bus.$emit('dealerId', value)
      // this.$router.push("/updateDealer");
      this.$store.state.popUpType = 'viewDealer'
      bus.$emit('popUpType', value)
      this.updateDealerModal = true
    },
    viewDeals: function (value, data) {
      // debugger
      this.$store.state.dealerId = value
      bus.$emit('dealerId', value)
      this.$store.state.dealerName = data
      bus.$emit('dealerName', data)
      // this.$router.push("/updateDealer");
      this.$store.state.popUpType = 'viewDeals'
      bus.$emit('popUpType', value)
      this.updateDealerModal = true
    },
    resetsearch () {
      console.log('Resetting the search and results'),
      (this.searchCriteria = this.createeEmptySearchObject()),
      (this.dealerListForDisplay = []),
      (this.norecordsfound = false)
      this.searchDealers()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#dealer').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
      console.log(txt)
    },
    checkAccess (permission) {
      return hasAccess(permission)
    }
  },

  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },

  mounted () {
    this.myFunction()
    this.menuheight()
    this.fetchDataOnpageLoad()
  }
}
</script>
<style scoped>
.btn-edit {
  font-size: 12px;
  padding: 0.2rem 0.75rem;
}
thead {
  position: sticky;
  top:0px ;  /* 0px if you don't have a navbar, but something is required */

}
.disabled {
  pointer-events: none;
  cursor: none;
}

</style>
